import type { DeckState } from "./board";
import type { IslandRecord } from "./types";
import { ISLANDS } from "./levels";

export type Phase = "intro" | "play" | "between" | "reveal" | "final";

export interface GameState {
  islandIdx: number;
  phase: Phase;
  deck: DeckState;
  /** shelfIdx -> uid of its placement, or null while it waits on the quay. */
  shelf: Array<number | null>;
  /** shelfIdx currently in hand, or null. */
  selected: number | null;
  /** 90° yaw on the held piece. */
  rotated: boolean;
  nextUid: number;
  records: Array<IslandRecord | null>;
}

export const state: GameState = {
  islandIdx: 0,
  phase: "intro",
  deck: { cols: 1, rows: 1, maxH: 1, placed: [] },
  shelf: [],
  selected: null,
  rotated: false,
  nextUid: 1,
  records: ISLANDS.map(() => null),
};
